// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

//import { getAnalytics, isSupported } from "firebase/analytics";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4OJZu9kztWGzIOjtCtrfpzw28DmsyO-w",
  authDomain: "gofoton-55796.firebaseapp.com",
  projectId: "gofoton-55796",
  storageBucket: "gofoton-55796.firebasestorage.app",
  messagingSenderId: "140236128179",
  appId: "1:140236128179:web:ab1788535f18aff05595c6",
  measurementId: "G-9HGZXDDRFE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

//const analytics = getAnalytics(app);

export { db, storage, auth };